<template>
  <div id="chi-tiet-don-vi">
    <div>
      <b-form class="chi-tiet-log-he-thong">
        <b-row v-if="hienThiXoaDonVi">
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Tên đơn vị:</span
            >
            <span>{{ chiTietDonVi.tenDonVi }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Mã đơn vị:</span
            >
            <span>{{ chiTietDonVi.maDonVi }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Đơn vị cha:</span
            >
            <span>{{ chiTietDonVi.tenDonViCha }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Mã liên thông:</span
            >
            <span>{{ chiTietDonVi.maLienThong }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Thứ tự:</span
            >
            <span>{{ chiTietDonVi.thuTu }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Mã liên thông mới:</span
            >
            <span>{{ chiTietDonVi.maLienThongMoi }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Mã đơn vị ghép:</span
            >
            <span>{{ chiTietDonVi.maDonViGhep }}</span>
          </b-col>

          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Số điện thoại:</span
            >
            <span>{{ chiTietDonVi.soDienThoai }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Email:</span
            >
            <span>{{ chiTietDonVi.email }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Fax:</span
            >
            <span>{{ chiTietDonVi.fax }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Loại đơn vị:</span
            >
            <span>{{ getLabelKieuDonVi(chiTietDonVi.bit_KieuDonVi) }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Trạng thái:</span
            >
            <span>{{
              getLabelTrangThai(chiTietDonVi.bit_TrangThaiDonVi)
            }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Loại đơn vị xử lý:</span
            >
            <span>{{ getLabelLoaiDonViXuLy(chiTietDonVi.loaiDonViXuLy) }}</span>
          </b-col>
          <b-col md="6" lg="6">
            <b-form-group
              label-class="font-weight-bold"
              label-for="Đơn vị có dấu"
            >
              <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
                >Đơn vị có dấu:</span
              >
              <span>
                <b-form-checkbox
                  class="d-inline-block"
                  :disabled="true"
                  v-model="chiTietDonVi.bit_DonViCoDau"
                  :value="1"
                  :unchecked-value="0"
                >
                </b-form-checkbox
              ></span>
            </b-form-group>
          </b-col>
          <b-col md="12" lg="6">
            <b-form-group
              label-class="font-weight-bold"
              label-for="loai đơn vị"
            >
              <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
                >Theo địa chỉ của đơn vị cha:</span
              >
              <span>
                <b-form-checkbox
                  class="d-inline-block"
                  :disabled="true"
                  v-model="chiTietDonVi.isDiaChiDonViCha"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox
              ></span>
            </b-form-group>
          </b-col>
          <b-col md="12" lg="3" class="d-flex mb-3">
              <span class="mr-3 font-weight-bold d-inline-block label"
                >Là đơn vị ảo:</span
              >
              <b-form-checkbox
                class="d-inline-block"
                :disabled="true"
                v-model="chiTietDonVi.isVirtualDepartment"
                :value="true"
                :unchecked-value="false"
              >
              </b-form-checkbox>
          </b-col>
          <b-col md="12" lg="3" class="d-flex mb-3">
              <span class="mr-3 font-weight-bold d-inline-block label"
                >Là đơn vị ngoài:</span
              >
              <b-form-checkbox
                class="d-inline-block"
                :disabled="true"
                v-model="chiTietDonVi.isExternalDepartment"
                :value="true"
                :unchecked-value="false"
              >
              </b-form-checkbox>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Tỉnh/TP:</span
            >
            <span>{{ chiTietDonVi.tinh }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Quận/huyện:</span
            >
            <span>{{ chiTietDonVi.huyen }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Phường/xã:</span
            >
            <span>{{ chiTietDonVi.xa }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Cấp đơn vị:</span
            >
            <span v-html="chiTietDonVi.moTaCapDonVis"></span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3">
            <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
              >Địa chỉ:</span
            >
            <span>{{ chiTietDonVi.diaChi }}</span>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex align-items-center mb-3">
              <span class="mr-3 font-weight-bold d-inline-block label"
                >Là đơn vị mới:</span
              >
              <b-form-checkbox
                class="d-inline-block"
                :disabled="true"
                v-model="chiTietDonVi.bit_DonViMoi"
                :value="true"
                :unchecked-value="false"
              >
              </b-form-checkbox>
          </b-col>
          <b-col sm="6" lg="6" class="d-flex mb-3"></b-col>
          <b-col sm="6" lg="6" class="d-flex align-items-center mb-3">
              <span class="mr-3 font-weight-bold d-inline-block"
                >Sử dụng hệ thống Quản lý văn bản:</span
              >
              <b-form-checkbox
                class="d-inline-block"
                :disabled="true"
                v-model="chiTietDonVi.bit_SuDungHeThong"
                :value="true"
                :unchecked-value="false"
              >
              </b-form-checkbox>
          </b-col>
          
        </b-row>
        <div class="text-center" v-else>Vui lòng chọn đơn vị.</div>
      </b-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChiTietDonVi",
  props: {
    chiTietDonVi: {},
    hienThiXoaDonVi: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getLabelKieuDonVi(kieuDonVi) {
      switch (kieuDonVi) {
        case 1:
          return "Đơn vị";
        case 2:
          return "Phòng ban";
        case 0:
          return "Phòng ban ảo";
      }
      return "";
    },
    getLabelLoaiDonViXuLy(kieuDonVi) {
      switch (kieuDonVi) {
        case 0:
          return "Vụ, cục, tương đương (thuộc bộ)";
        case 1:
          return "Vụ, cục (thuộc tổng cục)";
        case 2:
          return "Cục thống kê tỉnh";
        case 3:
          return "Tổng cục thống kê";
        case 4:
          return "Bộ";
      }
      return "";
    },
    getLabelTrangThai(bitTrangThai) {
      switch (bitTrangThai) {
        case 1:
          return "Hoạt động";
        case 2:
          return "Không hoạt động";
      }
    },
  },
};
</script>
